import React from "react";
import amaxLogo from "../images/amaxLogo.png";
import { Link } from "react-router-dom";
export const LogoCenter = () => {
  return (
    <Link to="/" className="size-[96px] lg:size-[166px]">
      <img src={amaxLogo} alt="logo" className="object-contain" />
    </Link>
  );
};
